<template>
  <div class="rapport-sessie">
    <table v-for="d in data" :key="d.Id" cellspacing="0" cellpadding="5">
      <thead>
        <tr>
          <td class="col-l">Datum</td>
          <td class="col-r">{{ d.Datum }}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="col-l">Cliënt</td>
          <td class="col-r">{{ d.Clientnummer }}</td>
        </tr>
        <tr>
          <td class="col-l">Geslacht</td>
          <td class="col-r">{{ d.Geslacht }}</td>
        </tr>
        <tr>
          <td class="col-l">Leeftijd</td>
          <td class="col-r">{{ d.LeeftijdCategorie }}</td>
        </tr>
        <tr>
          <td class="col-l">Woonprovincie cliënt</td>
          <td class="col-r">{{ d.Provincie }}</td>
        </tr>
        <tr>
          <td class="col-l">Locatie</td>
          <td class="col-r">{{ d.Locatie }}</td>
        </tr>
        <tr>
          <td class="col-l">Locatie</td>
          <td class="col-r">{{ d.Locatie }}</td>
        </tr>
        <tr>
          <td class="col-l">Wettelijke vertegenwoordiging</td>
          <td class="col-r">
            <span v-show="d.WettelijkeVertegenwoordiging == true">ja</span
            ><span v-show="d.WettelijkeVertegenwoordiging == false">nee</span>
          </td>
        </tr>
        <tr>
          <td class="col-l">Getekende toestemmingsverklaring</td>
          <td class="col-r">
            <span v-show="d.GetekendeToestemmingsverklaring == true">ja</span
            ><span v-show="d.GetekendeToestemmingsverklaring == false"
              >nee</span
            >
          </td>
        </tr>
        <tr>
          <td class="col-l">Vragenset</td>
          <td class="col-r">{{ d.Vragenset }}</td>
        </tr>
        <tr>
          <td class="col-l">Medewerkers</td>
          <td class="col-r">{{ d.Medewerkers }}</td>
        </tr>
        <tr>
          <td class="col-l">&nbsp;</td>
          <td class="col-r">&nbsp;</td>
        </tr>
        <tr v-for="v in d.Vragen" :key="v.Id">
          <td class="col-l">{{ v.Vraag }}</td>
          <td class="col-r"><span v-html="v.Antwoord"></span></td>
        </tr>
      </tbody>
    </table>
    <div v-if="data.length == 0 && clientnummer != ''">
      Geen gegevens gevonden voor dit cliëntnummer.
    </div>
    <button @click="download()" v-show="data.length > 0">Download Excel</button>
  </div>
</template>


<script>
export default {
  name: "rapportsessie",
  props: ["clientnummer"],
  components: {},
  data() {
    return {
      data: [],
    };
  },
  methods: {
    getRapport: function () {
      if (this.clientnummer && this.clientnummer != "") {
        this.$api
          .pRapportSessie({
            Clientnummer: this.clientnummer,
          })
          .then((response) => {
            this.data = response.data;
            this.$emit("loaddata", response.data.length);
          });
      }
    },
    download: function () {
      if (this.clientnummer && this.clientnummer != "") {
        this.$api
          .pRapportSessieExcel(
            {
              Clientnummer: this.clientnummer,
            },
            "excel"
          )
          .then((response) => {
            this.$api.saveDownload(
              response.data,
              "RapportPerSessie " + this.clientnummer + ".xlsx"
            );
          });
      }
    },
  },
  created: function () {
    this.getRapport();
  },
  watch: {
    clientnummer: function () {
      this.getRapport();
    },
  },
};
</script>


<style scoped>
table {
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid silver;
}

.rapport-sessie {
  margin-top: 10px;
  margin-bottom: 20px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr,
td {
  border-width: 0px;
}

.col-l {
  width: 50%;
}
.col-r {
  width: 50%;
}

thead {
  background-color: #00b4d1;
  color: #fff;
}
</style>
